import React from "react";
import "../Styles/view_more_1.css";

const Viewer = () => {
  return (
    <>
      {/* FIRST SECTION */}
      <section className="viewer">

        <div className="viewer-container">

          {/* LEFT */}
          <div className="viewer-left">

            <h1 className="viewer-title">
              Voices Of HR 2026 <br /> By Outstanding Workplaces
            </h1>

            <p className="viewer-subtitle">
              “Where Culture Comes Alive Through Conversations”
            </p>

            <div className="viewer-info">

              <div className="viewer-card">
                <img src="/assets/cal.png" alt="calendar" />
                <span>18th April, 2026 (Saturday)</span>
              </div>

              <div className="viewer-card">
                <img src="/assets/Vec.png" alt="clock" />
                <span>10:00 AM - 1:00 PM</span>
              </div>

            </div>

            <div className="viewer-card viewer-location">
              <img src="/assets/loc.png" alt="location" />
              <span>Bloom Hub Hotel, Guindy, Chennai.</span>
            </div>

          </div>


          {/* RIGHT IMAGE */}
          <div className="viewer-right">
            <img src="/assets/View_1.png" alt="conference" />
          </div>

        </div>

      </section>


      {/* SECOND SECTION - ABOUT EVENT */}

      <section className="about-event">

        <div className="about-container">

          <h2 className="about-title">About the Event</h2>

          <p className="about-text">
            Voices of HR 2026 by Outstanding Workplaces is a premier gathering of HR leaders,
            industry experts, and people-first organizations coming together to shape the future of work.
          </p>

          <p className="about-text">
            Centered around the theme “Where Culture Comes Alive Through Conversations,”
            this event is designed to spark meaningful dialogue, share transformative ideas,
            and celebrate excellence in workplace practices.
          </p>

          <p className="about-text">
            From insightful panel discussions and thought-provoking keynotes to high-impact networking
            opportunities, Voices of HR 2026 creates a dynamic platform where experiences are shared,
            perspectives are challenged, and innovative people strategies are born.
          </p>

          <p className="about-text">
            This is more than just an event—it’s a movement that brings together voices that inspire change,
            build stronger workplace cultures, and redefine what it means to be a great place to work.
          </p>

          <p className="about-text">
            Whether you're an HR professional, business leader, or culture champion, this is your opportunity
            to connect, learn, and lead the future of work.
          </p>

        </div>

      </section>

      {/* THIRD SECTION - EVENT HIGHLIGHTS */}

<section className="highlights">

  <div className="highlights-container">

    <h2 className="highlights-title">Event Highlights</h2>

    <ul className="highlights-list">

      <li>
        <img src="/assets/mat.png" alt="arrow" />
        Inspiring Keynote Session
      </li>

      <li>
        <img src="/assets/mat.png" alt="arrow" />
        Insightful Panel Discussions
      </li>

      <li>
        <img src="/assets/mat.png" alt="arrow" />
        HR Leader Talks (TA, Engagement, Leadership)
      </li>

      <li>
        <img src="/assets/mat.png" alt="arrow" />
        Exclusive Networking Opportunities
      </li>

    </ul>

  </div>

</section>

{/* FOURTH SECTION - AGENDA SNAPSHOT */}
<section className="agenda">
  <h2 className="agenda-title">Agenda Snapshot</h2>
  <div className="timeline">

    <div className="timeline-row">
      <div className="tl-left">
        <div className="tl-card">
          <span className="tl-card-text">09:30 AM – Registration</span>
        </div>
      </div>
      <div className="tl-center">
        <div className="tl-icon"><img src="/assets/eva.png" alt="" /></div>
      </div>
      <div className="tl-right"></div>
    </div>


    <div className="timeline-row">
      <div className="tl-left"></div>
      <div className="tl-center">
        <div className="tl-icon"><img src="/assets/file.png" alt="" /></div>
      </div>
      <div className="tl-right">
        <div className="tl-card">
          <span className="tl-card-text">10:00 AM – Opening Keynote</span>
        </div>
      </div>
    </div>


    <div className="timeline-row">
      <div className="tl-left">
        <div className="tl-card">
          <span className="tl-card-text">10:30 AM – Panel Discussion</span>
        </div>
      </div>
      <div className="tl-center">
        <div className="tl-icon"><img src="/assets/dash.png" alt="" /></div>
      </div>
      <div className="tl-right"></div>
    </div>


    <div className="timeline-row">
      <div className="tl-left"></div>
      <div className="tl-center">
        <div className="tl-icon"><img src="/assets/food.png" alt="" /></div>
      </div>
      <div className="tl-right">
        <div className="tl-card">
          <span className="tl-card-text">12:45 PM – Lunch &amp; Networking</span>
        </div>
      </div>
    </div>


    <div className="timeline-row">
      <div className="tl-left">
        <div className="tl-card">
          <span className="tl-card-text">01:00 PM – Closing Note</span>
        </div>
      </div>
      <div className="tl-center">
        <div className="tl-icon"><img src="/assets/tab.png" alt="" /></div>
      </div>
      <div className="tl-right"></div>
    </div>


  </div>
</section>


{/* Fivth SECTION - Map Section */}

<section className="map-section">

 <div className="map-container">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.3399335187783!2d80.22033957484214!3d13.014011587305248!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267d9a0942735%3A0xe21a01e16dbca99d!2sBloom%20Hub%20%7C%20Guindy!5e0!3m2!1sen!2sin!4v1775544984622!5m2!1sen!2sin"
    width="100%"
    height="300"               // reduced height for smaller size
    style={{ border: 0, borderRadius: '10px' }}  // optional rounded corners
    loading="lazy"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
    title="Bloom Hub Guindy Location Map" // <-- added title
  ></iframe>
</div>

</section>


    </>
  );
};

export default Viewer;